import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  getExportableBookingOrder,
  getSearchedBookingOrderList,
  getBookingOrderLogs,
  deleteBookingOrder,
} from "src/services/booking.services";
import { getUsedSearchedPlasticSealList } from "src/services/plastic-seal.services";
import { getSearchableStoreList } from "../../services/store.services";
import { getSearchAbleRoutes } from "../../services/route.services";
import { createMultipleOrders } from "../../services/trip.services";
import { getAllUserTypeBySearch } from "../../services/user-type.services";
import {
  CAvatar,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CFormLabel,
  CFormInput,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormCheck,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {
  cilPencil,
  cilPeople,
  cilPlus,
  cilTrash,
} from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import { useNavigate } from "react-router-dom";
import MessageModal from "src/components/MessageModal/MessageModal";
import Select from "react-select";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import toast from "react-hot-toast";
import { BsChevronDoubleUp, BsChevronDoubleDown } from "react-icons/bs";
import { getActiveCountryList } from "src/services/country.services";
import TableColumnSortIcon from "src/components/Sort/TableColumnSortIcon";
import useTableSort from "src/__custom_hook/useTableSort";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import BulkAssignTrip from "src/components/NewBookingOrderActionModal/BulkAssignTrip";
import useExportData from "src/__custom_hook/useExportData";
import DeleteConfirmationWithRemarks from "./DeleteConfirmationWithRemarks";
import { isCancel } from "axios";

const NewBookingOrdersTable = () => {
  //access User Data
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  // Access the current location
  const location = useLocation();
  const { exportData } = useExportData();

  const { sortConfig, setSortConfig, handleClickColumnSort } = useTableSort();

  // Parse the query parameters
  const searchParams = new URLSearchParams(location.search);
  const paramStatus = searchParams.get("status");
  const paramCountryId = searchParams.get("country");
  const paramPriority = searchParams.get("priority");
  // const paramStatus = '';
  // const paramPriority = '';

  const navigate = useNavigate();

  const [localUser, setLocalUser] = useState(user);
  const [isToast, addToast] = useState("");
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [bookingOrderId, setBookingOrderId] = useState("");
  const [transferOrderNo, setTransferOrderNo] = useState("");
  const [sealBag, setSealBag] = useState("");
  const [fromDate, setFromDate] = useState("");

  const [toDate, setToDate] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [tripRoute, setTripRoute] = useState("");
  const [tripName, setTripName] = useState("");
  const [bookingOrderStatus, setBookingOrderStatus] = useState("");
  const [storeDataArray, setStoreDataArray] = useState([]);
  const [selectedFromStoreOption, setSelectedFromStoreOption] = useState(null);
  const [selectedFromLocationCode, setSelectedFromLocationCode] =
    useState(null);
  const [selectedToStoreOption, setSelectedToStoreOption] = useState(null);
  const [selectedToLocationCode, setSelectedToLocationCode] = useState(null);
  const [locationCodeOptions, setLocationCodeOptions] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRouteOption, setSelectedRouteOption] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedSealOption, setSelectedSealOption] = useState(null);
  const [sealOptions, setSealOptions] = useState([]);
  const [sealArray, setSealArray] = useState([]);

  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedModalTitle, setSelectedModalTitle] = useState(null);
  const [visibleMessageModal, setVisibleMessageModal] = useState(false);
  const [bookingOrderLogs, setBookingOrderLogs] = useState([]);
  const [bookingOrderSelectedStatus, setBookingOrderSelectedStatus] =
    useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [storeUserData, setStoreUserData] = useState(null);
  const [priorityOptions, setPriorityOptions] = useState([
    { label: "normal", value: "normal" },
    { label: "emergency", value: "emergency" },
  ]);
  const [selectedPriorityOption, setSelectedPriorityOption] = useState(null);
  const [priority, setPriority] = useState("");

  const [selectAllStatus, setSelectAllStatus] = useState(false);

  const [countrySelectOptions, setCountrySelectOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [selectedDeletableItem, setSelectedDeletableItem] = useState(null)
  const [visibleDeleteConfirmationModal, setVisibleDeleteConfirmationModal] = useState(false)

  const [isSearchData, setIsSearchData] = useState(false);
  const [bulkTripId, setBulkTripId] = useState("");
  const queryClient = useQueryClient();
  const getBookingOrderAbortControllerRef = useRef(null);

  // Get Booking Order Logs Mutation
  const GetBookingOrderLogsMutation = useMutation({
    mutationKey: ["booking-orders-log"],
    mutationFn: (id) => getBookingOrderLogs(id),
    onMutate: () => {
      toast.loading("Getting history....");
    },
    onSuccess: (response) => {
      toast.dismiss();
      setBookingOrderLogs(response.data);
      const historyObj = {
        type: "history",
        data: response.data.reverse(),
      };
      setSelectedModalTitle("Booking Order History");
      setSelectedMessage(historyObj);
      setVisibleMessageModal(true);
    },
    onError: (error) => {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Something went wrong!!!");
    },
    onSettled: () => {
      queryClient.invalidateQueries(["booking-orders-log"]);
    },
  });

  // Create Multiple orders trip mutation
  const AssignMultipleTripMutation = useMutation({
    mutationKey: ["assign-multiple-trip"],
    mutationFn: (data) => createMultipleOrders(data),
    onMutate: () => {
      toast.loading("Loading....");
    },
    onSuccess: (res) => {
      toast.dismiss();
      const result = res.data;

      if (result) {
        const tripId = result.id;
        setBulkTripId(tripId);
        // if (
        //   selectedPriorityOption &&
        //   selectedPriorityOption.value === "emergency"
        // ) {
        //   const country = selectedCountry?.value;
        //   navigate(
        //     `/create-bulk-trip/${tripId}?priority=emergency${
        //       country ? "&country=" + country : ""
        //     }`,
        //     {
        //       replace: true,
        //     }
        //   );
        // } else {
        //   navigate("/create-bulk-trip/" + tripId, {
        //     replace: true,
        //   });
        // }
      }
    },
    onError: (error) => {
      console.log(error);
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
    onSettled: () => {
      queryClient.invalidateQueries(["assign-multiple-trip"]);
    },
  });

  const deleteBookingOrderMutation = useMutation({
    mutationKey: ["delete-booking-order"],
    mutationFn: (data) => deleteBookingOrder(data.id, data.remarks),
    onMutate: () => {
      toast.loading("Deleting booking order....");
    },
    onSuccess: (response) => {
      toast.dismiss();
      toast.success(response.message || "Booking order deleted successfully");
      getBookingOrderItem(1);
    },
    onError: (error) => {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
    onSettled: () => {
      queryClient.invalidateQueries(["delete-booking-order"]);
    },
  });

  const handleSubmit = () => {
    const searchParams = new URLSearchParams();

    if (selectedCountry?.value) searchParams.append('country', selectedCountry.value);
    if (bookingOrderSelectedStatus?.value) searchParams.append('status', bookingOrderSelectedStatus.value);
    
    if (fromDate) searchParams.append('from', moment(fromDate).format('YYYY-MM-DD')); // Format date
    if (fromTime) searchParams.append('fromTime', fromTime);
    if (toDate) searchParams.append('to', moment(toDate).format('YYYY-MM-DD')); // Format date
    if (toTime) searchParams.append('toTime', toTime);

    const queryString = searchParams.toString();

    // Navigate to the new URL
    navigate(`/manage-booking-orders${queryString ? `?${queryString}` : ''}`, { replace: true });

    setSelectAllStatus(false);
    setCurrentPage(1);
    getBookingOrderItem(1);
  };

  const handleReset = () => {
    setBookingOrderId("");
    setTransferOrderNo("");
    setFromDate("");
    setToDate("");
    setFromTime("");
    setToTime("");

    setTripName("");

    setSelectedToStoreOption("");
    setToLocation("");
    setSelectedToLocationCode("");

    setSelectedFromStoreOption("");
    setFromLocation("");
    setSelectedFromLocationCode("");

    setSelectedRouteOption("");
    setTripRoute("");

    setBookingOrderSelectedStatus("");
    setBookingOrderStatus("");

    setSelectedSealOption("");
    setSealBag("");

    setSelectedPriorityOption("");
    setPriority("");

    if (sortConfig.length > 0) {
      setSortConfig([]);
    }

    if (selectedCountry) {
      setSelectedCountry(null);
    }

    navigate(`/manage-booking-orders`, { replace: true });
    setCurrentPage(1);
    getBookingOrderItem(1);
  };

  const getUserType = () => {
    getAllUserTypeBySearch({ limit: 100, page: 1, type: "store" })
      .then(async (response) => {
        const userTypeInfo = response.data;
        if (userTypeInfo?.length > 0) {
          setStoreUserData(userTypeInfo[0]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    const urlFromTime = searchParams.get('fromTime') || '';
     if (fromTime !== urlFromTime) {
        setFromTime(urlFromTime);
    }

     const urlToTime = searchParams.get('toTime') || '';
     if (toTime !== urlToTime) {
        setToTime(urlToTime);
    }

    // Dates (parse from YYYY-MM-DD)
    const urlFromDateStr = searchParams.get('from');
    const urlFromDate = urlFromDateStr ? moment(urlFromDateStr, 'YYYY-MM-DD').toDate() : null;
    // Compare dates carefully (e.g., by time value or formatted string)
    if (moment(fromDate).format('YYYY-MM-DD') !== moment(urlFromDate).format('YYYY-MM-DD')) {
        setFromDate(urlFromDate);
    }

    const urlToDateStr = searchParams.get('to');
    const urlToDate = urlToDateStr ? moment(urlToDateStr, 'YYYY-MM-DD').toDate() : null;
     if (moment(toDate).format('YYYY-MM-DD') !== moment(urlToDate).format('YYYY-MM-DD')) {
        setToDate(urlToDate);
    }

    const urlCountryId = searchParams.get("country") || "";
    const currentCountry = urlCountryId || (user?.userType !== 'superAdmin' ? user?.country?._id : "");
    if(currentCountry && countrySelectOptions.length > 0) {
      const paramCountry = countrySelectOptions.find(
        (x) => x.value === currentCountry
      );
      setSelectedCountry(paramCountry);
    }

    setCurrentPage(1);
    getBookingOrderItem(1);
  }, [countrySelectOptions, location.search])

  useEffect(() => {
    const urlCountryId = searchParams.get("country") || "";
    if(urlCountryId && selectedCountry?.value) {
      getBookingOrderItem(1);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (localUser?.country) {
      setSelectedCountry({
        value: localUser.country._id,
        lebel: `${localUser.country.name}-${localUser.country.code}`,
      });
    }

    getUserType();
    getStatusList();

    if (paramStatus || paramPriority) {
      if (paramStatus) {
        setBookingOrderStatus(paramStatus);
        setBookingOrderSelectedStatus({
          label: paramStatus.charAt(0).toUpperCase() + paramStatus.slice(1),
          value: paramStatus,
        });
      }
      if (paramPriority) {
        setSelectedPriorityOption({
          label: paramPriority,
          value: paramPriority,
        });
        setPriority(paramPriority);
      }

      const param = {
        limit,
        page: currentPage,
        type: "manage",
        status: paramStatus ? paramStatus : "",
        priority: paramPriority ? paramPriority : "",
        from: fromDate
          ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "",
      };
      getBookingOrderItem(currentPage, param);
    } else {
      if (localUser?.userType !== "superAdmin") {
        getBookingOrderItem(currentPage);
      }
    }

    if (localUser?.userType === "superAdmin") {
      getActiveCountries();
    } else {
      getStoreInfo();
      getUsedSealInfo();
      getRouteNameList(null);
    }
  }, []);

  useEffect(() => {
    if (localUser?.userType === "superAdmin") {
      if (selectedCountry) {
        getStoreInfo(selectedCountry?.value);
        getRouteNameList(selectedCountry?.value);
        getUsedSealInfo(null, selectedCountry?.value);
      } else {
        if (!paramStatus && !paramPriority) {
          getBookingOrderItem(currentPage);
        }
        getUsedSealInfo();
        getRouteNameList(null);
        getStoreInfo();
        setSelectedCountry("");
      }
    }
  }, [selectedCountry]);

  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1 })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setCountrySelectOptions(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const getStoreInfo = (country = "") => {
    getSearchableStoreList({ country })
      .then(async (response) => {
        const storeData = response.data;
        setStoreDataArray(storeData);
        let options = [];
        let locationCodeOptions = [];
        storeData?.forEach((element) => {
          const option = { value: `${element._id}`, label: `${element.name}` };
          const codeOption = {
            value: `${element._id}`,
            label: element.locationCode ? element.locationCode : "N/A",
          };
          options.push(option);
          locationCodeOptions.push(codeOption);
        });
        setStoreOptions(options);
        setLocationCodeOptions(locationCodeOptions);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getRouteNameList = (country, searchString = "") => {
    getSearchAbleRoutes({ country, searchString })
      .then(async (response) => {
        const fetchedRouteData = response.data;
        let options = [];

        fetchedRouteData.forEach((element) => {
          const option = { value: `${element._id}`, label: `${element.name}` };
          options.push(option);
        });

        setRouteOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getStatusList = () => {
    const statusObj = [
      { name: "All", value: "" },
      { name: "CDT", value: "cvit" },
      { name: "New", value: "new" },
      { name: "Assigned", value: "assigned" },
      { name: "Accepted", value: "driver" },
      { name: "Delivered", value: "delivered" },
      { name: "Rejected", value: "rejected" },
      { name: "Active", value: "active" },
    ];
    let options = [];
    statusObj.forEach((element) => {
      const option = { value: `${element.value}`, label: `${element.name}` };
      options.push(option);
    });
    setStatusOptions(options);
  };

  const getBookingOrderItem = (page, param = null) => {
    // --- AbortController Logic Start ---
    // Cancel the previous request if it's still ongoing
    if (getBookingOrderAbortControllerRef.current) {
      getBookingOrderAbortControllerRef.current.abort();
    }
    // Create a new AbortController for the current request
    const controller = new AbortController();
    getBookingOrderAbortControllerRef.current = controller;
    // --- AbortController Logic End ---

    if (fromDate && toDate && moment(toDate).isBefore(moment(fromDate))) {
      toast.error("To date cannot be before from date");
      return;
    }

    const params = param
      ? param
      : {
        limit,
        page: page,
        type: "manage",
        bookingOrderId,
        tripName,
        sealBag,
        transferOrderNo,
        fromLocation: fromLocation,
        toLocation: toLocation,
        tripRoute: tripRoute,
        from: fromDate
          ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "",
        to: toDate ? moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
        fromTime: fromTime,
        toTime: toTime,
        status: bookingOrderStatus,
        priority,
        country: selectedCountry ? selectedCountry.value : "",
        sort: sortConfig
          .map((config) => `${config.key}:${config.direction}`)
          .join(","),
      };
    setIsLoading(true);
    getSearchedBookingOrderList(params, { signal: controller.signal })
      .then(async (response) => {
        // Reset the abort controller ref since the request completed successfully
        getBookingOrderAbortControllerRef.current = null;
        // setSelectedCheckboxes([]);
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        if (selectAllStatus && bookingOrderSelectedStatus) {
          let selectedItems = [];
          response.data.map((item) => {
            if (item.status === "cvit") {
              selectedItems.push(item._id);
            }
          });
          setSelectedCheckboxes((prev) => [...prev, ...selectedItems]);
        }
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
        isSearchFieldEmpty() ? setIsSearchData(false) : setIsSearchData(true);
      })
      .catch((error) => {
        // --- Abort Error Handling Start ---
        // Check if the error is due to cancellation (using axios's isCancel as an example)
        // For native fetch, check: if (error.name === 'AbortError')
        if (isCancel(error) || error.name === 'AbortError') {
          console.log('Request canceled:', error.message);
          // Don't set loading to false here if another request is likely already running
          // Optionally reset the controller ref here too if needed, though the next call will overwrite it
          // getBookingOrderAbortControllerRef.current = null;
          return; // Ignore cancellation errors
        }
        // --- Abort Error Handling End ---

        // Handle actual errors
        getBookingOrderAbortControllerRef.current = null; // Reset on actual error too
        
        setIsLoading(false);
        console.error(error);
      });
  };

  // --- Cleanup Effect ---
  useEffect(() => {
    // Cleanup function to abort the request if the component unmounts
    return () => {
      if (getBookingOrderAbortControllerRef.current) {
        getBookingOrderAbortControllerRef.current.abort();
        getBookingOrderAbortControllerRef.current = null;
      }
    };
  }, []); // Empty dependency array ensures this runs only on mount and unmount


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getBookingOrderItem(newPage);
  };

  const handleAssignTrip = (event) => {
    const { id, status } = event.currentTarget.dataset; // Assuming the ID is stored as a data attribute
    if (status === "cvit" && localUser.permission.manage_trip) {
      navigate("/create-trip/" + id);
    }
  };

  const handleRejectDetails = (value) => {
    setSelectedMessage(value);
    setVisibleMessageModal(true);
  };

  const handleDeliveredDetails = (
    deliverEmployeeCode,
    deliverSignature,
    deliverTo,
    deliverImage
  ) => {
    const deliverObj = {
      type: "deliver",
      deliverEmployeeCode,
      deliverSignature,
      deliverTo,
      deliverImage,
    };
    setSelectedModalTitle("Receiver's Details");
    setSelectedMessage(deliverObj);
    setVisibleMessageModal(true);
  };

  // const handleDriverDetails = (driver, vehicleId) => {
  const handleDriverDetails = (driver, tagId) => {
    const driverObj = {
      type: "driver",
      firstName: driver.firstName,
      lastName: driver.lastName,
      tagId: tagId,
      // vehicleId: vehicleId,
      avatar: driver.avatar,
    };
    setSelectedModalTitle("Driver Details");
    setSelectedMessage(driverObj);
    setVisibleMessageModal(true);
  };

  const handleHistoryDetails = async (e, itemId) => {
    e.stopPropagation();
    GetBookingOrderLogsMutation.mutate(itemId);
  };

  const exportToExcel = async () => {
    try {
      toast.loading("Preparing downloads...");

      const param = {
        type: "manage",
        bookingOrderId,
        sealBag,
        tripName,
        transferOrderNo,
        fromLocation: fromLocation,
        toLocation: toLocation,
        tripRoute: tripRoute,
        from: fromDate
          ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "",
        to: toDate ? moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
        fromTime: fromTime,
        toTime: toTime,
        status: bookingOrderStatus,
        priority,
        sort: sortConfig
          .map((config) => `${config.key}:${config.direction}`)
          .join(","),
        sort: sortConfig
          .map((config) => `${config.key}:${config.direction}`)
          .join(","),
        country: selectedCountry ? selectedCountry.value : "",
        fileType: "excel",
      };
      exportData(param);
    } catch (error) {
      toast.dismiss();
      console.error(error);
    } finally {
      toast.dismiss();
    }
  };

  const fetchApiDataAndDownloadPDF = async () => {
    try {
      toast.loading("Preparing downloads!!!");
      const param = {
        type: "manage",
        bookingOrderId,
        sealBag,
        tripName,
        transferOrderNo,
        fromLocation: fromLocation,
        toLocation: toLocation,
        tripRoute: tripRoute,
        from: fromDate
          ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
          : "",
        to: toDate ? moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
        fromTime: fromTime,
        toTime: toTime,
        status: bookingOrderStatus,
        country: selectedCountry?.value,
        priority,
        sort: sortConfig
          .map((config) => `${config.key}:${config.direction}`)
          .join(","),
        country: selectedCountry ? selectedCountry.value : "",
        fileType: "pdf",
      };

      exportData(param);
    } catch (error) {
      toast.dismiss();
      console.error(error);
    } finally {
      toast.dismiss();
    }
  };

  const handleChangeFromStore = (selectedOption) => {
    if (selectedOption) {
      setSelectedFromStoreOption(selectedOption);
      setFromLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedFromLocationCode({
        value: storeObj._id,
        label: storeObj.locationCode ? storeObj.locationCode : "N/A",
      });
    } else {
      setSelectedFromStoreOption("");
      setFromLocation("");
      setSelectedFromLocationCode(null);
    }
  };

  const handleChangeFromLocationCode = (selectedOption) => {
    if (selectedOption) {
      setSelectedFromLocationCode(selectedOption);
      setFromLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedFromStoreOption({ value: storeObj._id, label: storeObj.name });
    } else {
      setSelectedFromLocationCode("");
      setSelectedFromStoreOption("");
      setFromLocation("");
    }
  };

  const handleChangeToStore = (selectedOption) => {
    if (selectedOption) {
      setSelectedToStoreOption(selectedOption);
      setToLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedToLocationCode({
        value: storeObj._id,
        label: storeObj.locationCode ? storeObj.locationCode : "N/A",
      });
      setSelectedRouteOption({
        value: storeObj?.route?._id,
        label: storeObj?.route?.name,
      });
    } else {
      setSelectedToLocationCode("");
      setSelectedToStoreOption("");
      setToLocation("");
      setSelectedRouteOption("");
    }
  };

  const handleChangeToLocationCode = (selectedOption) => {
    if (selectedOption) {
      setSelectedToLocationCode(selectedOption);
      setToLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedToStoreOption({ value: storeObj._id, label: storeObj.name });
      setSelectedRouteOption({
        value: storeObj?.route?._id,
        label: storeObj?.route?.name,
      });
    } else {
      setSelectedToLocationCode("");
      setSelectedToStoreOption("");
      setToLocation("");
      setSelectedRouteOption("");
    }
  };

  const handleChangeRoute = (selectedOption) => {
    setSelectedCheckboxes([]);
    if (selectedOption) {
      setSelectedRouteOption(selectedOption);
      setTripRoute(selectedOption.value);
    } else {
      setSelectedRouteOption("");
      setTripRoute("");
    }
  };

  const handleOnInputChangeRoute = (searchValue) => {
    if (searchValue) {
      const matchingRoutes = routeOptions.filter((route) =>
        route.label.toLowerCase().includes(searchValue.toLowerCase())
      );
      if (matchingRoutes.length <= 0) {
        getRouteNameList(selectedCountry?.value, searchValue);
      }
    }
  };

  const handleChangeStatus = async (selectedOption) => {
    setSelectAllStatus(false);
    setSelectedCheckboxes([]);
    if (selectedOption) {
      setBookingOrderSelectedStatus(selectedOption);
      setBookingOrderStatus(selectedOption.value);
    } else {
      setBookingOrderSelectedStatus("");
      setBookingOrderStatus("");
    }
  };

  const handleChangePriority = (selectedOption) => {
    setSelectAllStatus(false);
    setSelectedCheckboxes([]);
    if (selectedOption) {
      setSelectedPriorityOption(selectedOption);
      setPriority(selectedOption.value);
    } else {
      setSelectedPriorityOption("");
      setPriority("");
    }
  };

  const handleChangeSeal = (selectedOption) => {
    if (selectedOption) {
      setSelectedSealOption(selectedOption);
      setSealBag(selectedOption.value);
    } else {
      setSelectedSealOption("");
      setSealBag("");
    }
  };

  const handleOnInputChangeSeal = (selectedOption) => {
    if (selectedOption) {
      const expectedData = sealArray.find((a) => a.includes(selectedOption));
      if (!expectedData) {
        getUsedSealInfo(selectedOption);
      }
    }
  };

  const getUsedSealInfo = async (searchedString = "", country = "") => {
    const limit = 10;
    const page = 1;
    getUsedSearchedPlasticSealList({ limit, page, searchedString, country })
      .then(async (response) => {
        const storeData = response.data;
        let options = [];
        let serialArray = [];

        storeData.forEach((element) => {
          const option = {
            value: `${element._id}`,
            label: `${element.serialNo}`,
          };
          options.push(option);
          serialArray.push(element.serialNo);
        });
        setSealArray(serialArray);
        setSealOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const createMultipleOrderTrip = async () => {
    if (selectedCheckboxes.length < 1) {
      toast("Here is your toast.");
    }


    if (fromDate && toDate && moment(toDate).isBefore(moment(fromDate))) {
      toast.error("To date cannot be before from date");
      return;
    }

    const params = {
      bookingOrders: selectedCheckboxes,
      status: bookingOrderSelectedStatus
        ? bookingOrderSelectedStatus.value
        : null,
      priority: selectedPriorityOption ? selectedPriorityOption.value : null,
      route: selectedRouteOption ? selectedRouteOption.value : null,
      selectAllStatus,
      fromLocation: fromLocation,
      toLocation: toLocation,
      tripRoute: tripRoute,
      from: fromDate ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
      to: toDate ? moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
      fromTime: fromTime,
      toTime: toTime,
      country: selectedCountry ? selectedCountry.value : "",
    };

    if (localUser?.userType === "superAdmin" && !selectedCountry?.value) {
      toast.error("Please select a country and try again");
      return;
    } else {
      params.country = selectedCountry?.value;
    }

    AssignMultipleTripMutation.mutate(params);

    // let referenceOrder = data.find(
    //   (order) => order._id === selectedCheckboxes[0]
    // );
    // let tripId = referenceOrder?.tripRoute?._id;
    // if (referenceOrder && tripId) {
    //   const selectedFilteredOrders = data.filter((order) =>
    //     selectedCheckboxes.includes(order._id)
    //   );

    //   const allOrdersHaveSameRoute = selectedFilteredOrders.every(
    //     (item) => item?.tripRoute?._id === tripId
    //   );

    //   if (allOrdersHaveSameRoute) {
    //     const params = {
    //       bookingOrders: selectedCheckboxes,
    //     };
    //     createMultipleOrders(params)
    //       .then(async (response) => {
    //         setIsLoading(false);
    //         const tripId = response.data?.id;
    //         navigate("/create-bulk-trip/" + tripId, {
    //           replace: true,
    //         });
    //       })
    //       .catch((error) => {
    //         setIsLoading(false);
    //         console.error(error);
    //       });
    //   } else {
    //     setSelectedCheckboxes([]);
    //     toast.error(
    //       "Please select the orders from same route to assign trip"
    //     );
    //   }
    // } else {
    //   toast.error("To Location is not assigned to any route");
    // }
    // }
  };

  const handleCheckBox = (event) => {
    event.stopPropagation();
    const { value } = event.target;
    // if (selectAllStatus) {
    //   setSelectAllStatus(false);
    // }
    if (selectedCheckboxes.includes(value)) {
      setSelectedCheckboxes(
        selectedCheckboxes.filter((item) => item !== value)
      );
    } else {
      setSelectedCheckboxes([...selectedCheckboxes, value]);
    }
  };

  const handleAllSelectCheckBox = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const isChecked = event.target.checked;

    setSelectAllStatus(isChecked);

    const cvitItems = data.filter((item) => item.status === "cvit");
    const cvitIds = cvitItems.map((item) => item._id);

    if (isChecked) {
      setSelectedCheckboxes(cvitIds);
    } else {
      setSelectedCheckboxes([]);
    }
  };

  const handleDateChange = (date, identity) => {
    if (!identity) return;
    if (!date) {
      // Clear the date if the input is empty
      if (identity === "from") {
        setFromDate("");
      } else if (identity === "to") {
        setToDate("");
      }
      return;
    }
    const today = moment().toDate();
    if (identity === "from") {
      if (date && moment(today).diff(moment(date), 'days') > 30) {
        const next30Days = moment(date).add(30, 'days').toDate();
        setToDate(next30Days);
      }

      setFromDate(date);

    }
    if (identity === "to") setToDate(date);
  };

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedCountry(selectedOption);
    } else {
      setSelectedCountry(null);
    }
    setFromLocation(null);
    setSelectedFromLocationCode("");
    setSelectedFromStoreOption(null);
    setToLocation(null);
    setSelectedToLocationCode("");
    setSelectedToStoreOption(null);
    setSealBag(null);
    setSelectedSealOption(null);
    setTripRoute("");
    setSelectedRouteOption(null);
  };

  const isSearchFieldEmpty = () => {
    if (
      bookingOrderId ||
      transferOrderNo ||
      sealBag ||
      fromDate ||
      toDate ||
      fromTime ||
      toTime ||
      fromLocation ||
      toLocation ||
      tripRoute ||
      bookingOrderStatus ||
      priority
    ) {
      return false;
    }
    return true;
  };

  const handleCloseModal = () => {
    setBulkTripId(null);
    setSelectedCheckboxes([]);
    setSelectAllStatus(false);
    setCurrentPage(1);
    getBookingOrderItem(1);
  };

  const handleDeleteBookingOrder = async (id) => {
    // if (await showConfirmToast('Are you sure you want to perform this action?')) {
    // }
    setSelectedDeletableItem(id);
    setVisibleDeleteConfirmationModal(true);
  };


  useEffect(() => {
    setCurrentPage(1);
    getBookingOrderItem(1);
  }, [sortConfig]);

  return (
    <>
      {bulkTripId && (
        <BulkAssignTrip
          {...{
            bulkTripId,
            setBulkTripId,
            priority:
              selectedPriorityOption &&
                selectedPriorityOption.value === "emergency"
                ? "emergency"
                : "normal",
            country: selectedCountry?.value,
            handleCloseModal,
          }}
        />
      )}

      <CCard className="mb-4">
        <CCardBody>
          <div className="position-absolute p-2 top-0 end-0">
            <CButton
              type="button"
              size="sm"
              className="bg-none"
              color="primary"
              onClick={() => setShowAdditionalFields((prev) => !prev)}
            >
              {showAdditionalFields ? (
                <BsChevronDoubleUp size={15} />
              ) : (
                <BsChevronDoubleDown size={15} />
              )}
            </CButton>
          </div>
          <CRow className="mb-1">
            <CCol sm={12} md={3}>
              <CFormLabel htmlFor="bookingOrderId">
                Booking Order ID:
              </CFormLabel>
              <CFormInput
                type="text"
                value={bookingOrderId}
                onChange={(e) => setBookingOrderId(e.target.value)}
                placeholder="example:DD001"
              />
            </CCol>
            <CCol sm={12} md={6}>
              <CRow>
                <CCol md={5}>
                  <CFormLabel htmlFor="bookingOrderId">Trip Name:</CFormLabel>
                  <CFormInput
                    type="text"
                    value={tripName}
                    onChange={(e) => setTripName(e.target.value)}
                    placeholder="example trip"
                  />
                </CCol>
                <CCol sm={7}>
                  <CFormLabel htmlFor="bookingOrderId">Route Name:</CFormLabel>
                  <Select
                    value={selectedRouteOption}
                    onChange={handleChangeRoute}
                    onInputChange={handleOnInputChangeRoute}
                    options={routeOptions}
                    isClearable={true}
                  />
                </CCol>
              </CRow>
            </CCol>

            <CCol sm={3}>
              <CRow className="mb-1">
                {localUser && localUser.userType === "superAdmin" && (
                  <CCol sm={7} md={7}>
                    <CFormLabel>Country:</CFormLabel>

                    <Select
                      value={selectedCountry}
                      onChange={handleCountryChange}
                      options={countrySelectOptions}
                      isClearable={true}
                    />
                  </CCol>
                )}

                <CCol
                  sm={localUser && localUser.userType === "superAdmin" ? 5 : 12}
                >
                  <CFormLabel htmlFor="bookingOrderId">Status:</CFormLabel>
                  <Select
                    value={bookingOrderSelectedStatus}
                    onChange={handleChangeStatus}
                    options={statusOptions}
                    isClearable={true}
                  />
                </CCol>
              </CRow>
            </CCol>
          </CRow>

          <div
            style={{
              maxHeight: showAdditionalFields ? "100%" : "0",
              transition: "max-height 0.5s ease",
            }}
          >
            {showAdditionalFields && (
              <CRow className="mb-1">
                <CCol sm={12} md={3}>
                  <CRow className="mb-1">
                    <CFormLabel htmlFor="bookingOrderId">
                      Transfer Order No.
                    </CFormLabel>
                    <CCol sm={12}>
                      <CFormInput
                        type="text"
                        placeholder="example:DD001"
                        value={transferOrderNo}
                        onChange={(e) => setTransferOrderNo(e.target.value)}
                      />
                    </CCol>
                  </CRow>
                </CCol>

                <CCol sm={12} md={6}>
                  <CRow>
                    <CCol sm={5}>
                      <CFormLabel htmlFor="fromLocationCode">
                        From Location Code:
                      </CFormLabel>
                      <Select
                        id="fromLocationCode"
                        value={selectedFromLocationCode}
                        onChange={handleChangeFromLocationCode}
                        options={locationCodeOptions}
                        isClearable={true}
                      />
                    </CCol>
                    <CCol sm={7}>
                      <CFormLabel htmlFor="fromLocationName">
                        From Location Name:
                      </CFormLabel>
                      <Select
                        id="fromLocationName"
                        value={selectedFromStoreOption}
                        onChange={handleChangeFromStore}
                        options={storeOptions}
                        isClearable={true}
                      // isDisabled={selectedCountry ? false : true}
                      />
                    </CCol>
                  </CRow>
                </CCol>
                <CCol sm={12} md={3}>
                  <CRow>
                    <CFormLabel htmlFor="bookingOrderId">From Date:</CFormLabel>
                    <CCol sm={7}>
                      <ReactDatePicker
                        showIcon={true}
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        onChange={(date) => handleDateChange(date, "from")}
                        selected={fromDate}
                      />
                    </CCol>
                    <CCol sm={5}>
                      <CFormInput
                        type="time"
                        value={fromTime}
                        onChange={(e) => setFromTime(e.target.value)}
                      />
                    </CCol>
                  </CRow>
                </CCol>
                <CCol sm={12} md={3}>
                  <CRow className="mb-1">
                    <CCol sm={12} md={6}>
                      <CFormLabel htmlFor="bookingOrderId">
                        Seal/Bag No.
                      </CFormLabel>
                      <Select
                        value={selectedSealOption}
                        onChange={handleChangeSeal}
                        onInputChange={handleOnInputChangeSeal}
                        options={sealOptions}
                        isClearable={true}
                      />
                    </CCol>
                    <CCol sm={6}>
                      <CFormLabel htmlFor="bookingOrderId">
                        Priority:
                      </CFormLabel>
                      <Select
                        value={selectedPriorityOption}
                        onChange={handleChangePriority}
                        options={priorityOptions}
                        isClearable={true}
                        className="text-capitalize"
                      />
                    </CCol>
                  </CRow>
                </CCol>

                <CCol sm={12} md={6}>
                  <CRow className="mb-1">
                    <CCol sm={5}>
                      <CFormLabel htmlFor="toLocationCode">
                        To Location Code:
                      </CFormLabel>
                      <Select
                        id="toLocationCode"
                        value={selectedToLocationCode}
                        onChange={handleChangeToLocationCode}
                        options={locationCodeOptions}
                        isClearable={true}
                      />
                    </CCol>
                    <CCol sm={7}>
                      <CFormLabel htmlFor="toLocationName">
                        To Location Name:
                      </CFormLabel>
                      <Select
                        id="toLocationName"
                        value={selectedToStoreOption}
                        onChange={handleChangeToStore}
                        options={storeOptions}
                        isClearable={true}
                      />
                    </CCol>
                  </CRow>
                </CCol>

                <CCol sm={12} md={3}>
                  <CRow className="mb-1">
                    <CFormLabel htmlFor="bookingOrderId">To Date:</CFormLabel>
                    <CCol sm={7}>
                      <ReactDatePicker
                        showIcon={true}
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        onChange={(date) => handleDateChange(date, "to")}
                        selected={toDate}
                      />
                    </CCol>
                    <CCol sm={5}>
                      <CFormInput
                        type="time"
                        value={toTime}
                        onChange={(e) => setToTime(e.target.value)}
                      />
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            )}
          </div>

          <div className="d-flex justify-content-end mt-3">
            <CButton
              type="button"
              color="primary"
              className="px-5 py-2 me-3"
              onClick={handleSubmit}
            >
              Submit
            </CButton>
            <CButton
              type="submit"
              className="px-5 py-2 ms-3 btn-oliveGreen"
              onClick={handleReset}
            >
              Reset
            </CButton>
          </div>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={7}>
              <h4 id="traffic" className="card-title mb-0">
                Manage Booking Orders - Total: {count}
              </h4>
              {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
            </CCol>
            <CCol sm={5} className="d-none d-md-block">
              <div className="d-flex justify-content-end gap-4">
                {["superAdmin", "admin", "cvit"].includes(user.userType) &&
                  selectedCheckboxes.length > 1 ? (
                  <CButton
                    onClick={createMultipleOrderTrip}
                    disabled={AssignMultipleTripMutation.isLoading}
                  >
                    <CIcon icon={cilPlus} />
                    &nbsp; Assign Trip
                  </CButton>
                ) : (
                  ""
                )}

                <CButtonGroup
                  role="group"
                  aria-label="Button group with nested dropdown"
                  style={{ marginRight: "10px" }}
                >
                  <CDropdown variant="btn-group">
                    <CDropdownToggle color="primary">Export</CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem
                        onClick={fetchApiDataAndDownloadPDF}
                      >
                        as PDF
                      </CDropdownItem>
                      <CDropdownItem onClick={exportToExcel}>
                        as Excel
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                </CButtonGroup>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                {["superAdmin", "admin", "cvit"].includes(user.userType) && (
                  <CTableHeaderCell className="text-center">
                    {bookingOrderSelectedStatus.value === "cvit" ||
                      bookingOrderSelectedStatus.value === "new" ||
                      priority === "emergency" ? (
                      <CFormCheck
                        id="AllSelectBox"
                        onChange={handleAllSelectCheckBox}
                        checked={selectAllStatus}
                        style={{
                          width: "20px",
                          height: "20px",
                          margin: "0px 10px",
                        }}
                      />
                    ) : (
                      "Select"
                    )}
                  </CTableHeaderCell>
                )}

                <CTableHeaderCell className="text-center">
                  Status
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  History
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Action
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("bookingOrderId")}
                  style={{ cursor: "pointer" }}
                >
                  Booking Order ID
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "bookingOrderId" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("transferOrderNo")}
                  style={{ cursor: "pointer" }}
                >
                  Transfer Order No.
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "transferOrderNo" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("sealBag")}
                  style={{ cursor: "pointer" }}
                >
                  Seal/Bag No.
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "sealBag" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("fromLocation")}
                  style={{ cursor: "pointer" }}
                >
                  From Location{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "fromLocation" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("toLocation")}
                  style={{ cursor: "pointer" }}
                >
                  To Location{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "toLocation" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("type")}
                  style={{ cursor: "pointer" }}
                >
                  Type{" "}
                  <TableColumnSortIcon {...{ sortConfig, dataKey: "type" }} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("unit")}
                  style={{ cursor: "pointer" }}
                >
                  Unit
                  <TableColumnSortIcon {...{ sortConfig, dataKey: "unit" }} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("tripId")}
                  style={{ cursor: "pointer" }}
                >
                  Trip Name{" "}
                  <TableColumnSortIcon {...{ sortConfig, dataKey: "tripId" }} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("tripRoute")}
                  style={{ cursor: "pointer" }}
                >
                  Route Name{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "tripRoute" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Priority
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("pickupDateTime")}
                  style={{ cursor: "pointer" }}
                >
                  Pick Up Date{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "pickupDateTime" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Remarks
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Created At{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "createdAt" }}
                  />
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="20">Loading...</CTableDataCell>
                </CTableRow>
              ) : !data || (data && data.length == 0) ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="20">
                    No data available
                  </CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow
                    v-for="item in tableItems"
                    key={index}
                    data-id={item._id}
                    data-status={item.status}
                    onClick={(e) => handleAssignTrip(e)}
                  >
                    {["superAdmin", "admin", "cvit"].includes(
                      user.userType
                    ) && (
                        <CTableDataCell className="text-center">
                          <CFormCheck
                            id={item._id}
                            value={item._id}
                            disabled={
                              item.status !== "cvit" ||
                              (priority &&
                                priority === "emergency" &&
                                item.priority !== "emergency")
                            }
                            defaultChecked={selectedCheckboxes.includes(item._id)}
                            onClick={handleCheckBox}
                            style={{
                              width: "20px",
                              height: "20px",
                              margin: "0px 10px",
                            }}
                          />
                        </CTableDataCell>
                      )}
                    <CTableDataCell className="text-center">
                      {item.status === "New" ? (
                        <CButton
                          color="secondary"
                          className="text-capitalize"
                          size="sm"
                          style={{ color: "white" }}
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status === "rejected" ? (
                        <CButton
                          color="danger"
                          className="text-capitalize"
                          size="sm"
                          style={{ color: "white" }}
                          onClick={() =>
                            handleRejectDetails(item?.rejectReason)
                          }
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status === "driver" ? (
                        <CButton
                          color="purple"
                          className="text-capitalize"
                          size="sm"
                          onClick={() =>
                            handleDriverDetails(
                              item?.tripAssignedTo,
                              item?.tripTagId
                              // item?.tripVehicleId
                            )
                          }
                        >
                          Accepted
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status === "delivered" ? (
                        <CButton
                          color="success"
                          className="text-capitalize"
                          size="sm"
                          style={{ color: "white" }}
                          onClick={() =>
                            handleDeliveredDetails(
                              item?.deliverEmployeeCode,
                              item?.deliverSignature,
                              item?.deliverTo,
                              item?.deliverImage
                            )
                          }
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status === "cvit" && (
                        <>
                          {item.isTransffered ? (
                            item.createdBy?.userType === storeUserData?._id ? (
                              <CButton
                                color="pink"
                                size="sm"
                                className="text-capitalize"
                              >
                                CDT
                              </CButton>
                            ) : (
                              <CButton
                                color="pink"
                                size="sm"
                                className="text-capitalize"
                              >
                                CDT
                              </CButton>
                            )
                          ) : item.createdBy?.userType === storeUserData?._id &&
                            item.isTransffered === false ? (
                            <CButton
                              color="lightBlue"
                              size="sm"
                              className="text-capitalize"
                            >
                              New
                            </CButton>
                          ) : (
                            <CButton
                              color="pink"
                              size="sm"
                              className="text-capitalize"
                            >
                              CDT
                            </CButton>
                          )}
                        </>
                      )}

                      {item.status === "assigned" ? (
                        <CButton
                          color="gray"
                          className="text-capitalize"
                          size="sm"
                          onClick={() =>
                            handleDriverDetails(
                              item?.tripAssignedTo,
                              // item?.tripVehicleId
                              item?.tripTagId
                            )
                          }
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center text-capitalize">
                      <CButton
                        color="primary"
                        className="text-capitalize"
                        size="sm"
                        style={{ color: "white" }}
                        onClick={(e) => handleHistoryDetails(e, item?._id)}
                      >
                        Show History
                      </CButton>
                    </CTableDataCell>
                    <CTableDataCell className="text-start">
                      {user &&
                        <>
                          {(user.permission["update_booking_order"] ||
                            user.permission["can_update_booking_order_status"]) ? (
                            <>
                              <Link
                                to={`/update-booking-orders/${item._id}`}
                                className="btn btn-primary btn-sm me-2"
                                target="_blank"
                                onClick={(event) => event.stopPropagation()}
                              >
                                <CIcon icon={cilPencil} />
                              </Link>

                            </>
                          ) : (
                            "N/A"
                          )}
                          {user.permission["delete_booking_order"] && ["pending", "cvit"].includes(item.status) && (
                            <CButton
                              color="danger"
                              size="sm"
                              onClick={(event) => {
                                event.stopPropagation();
                                handleDeleteBookingOrder(item._id);
                              }}
                            >
                              <CIcon icon={cilTrash} className="text-white" />
                            </CButton>
                          )}
                        </>
                      }
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.status == "cvit" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.orderAcceptRejectBy?.avatar
                              ? item.orderAcceptRejectBy.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "rejected" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.orderAcceptRejectBy?.avatar
                              ? item.orderAcceptRejectBy.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "assigned" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.tripAssignedBy?.avatar
                              ? item.tripAssignedBy.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "driver" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.tripAssignedTo?.avatar
                              ? item.tripAssignedTo.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "delivered" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.tripAssignedTo?.avatar
                              ? item.tripAssignedTo.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.bookingOrderId}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.transferOrderNo}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.sealBag?.serialNo}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.fromLocation
                        ? `${item.fromLocation.name} (${item.fromLocation.locationCode})`
                        : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.toLocation
                        ? `${item.toLocation.name} (${item?.toLocation?.locationCode})`
                        : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.type ? item.type.name : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.unit ? item.unit.name : ""}
                    </CTableDataCell>
                    <CTableDataCell>{item?.tripId?.tripName}</CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.tripRoute?.name}
                    </CTableDataCell>
                    <CTableDataCell className={`text-center text-capitalize ${item.priority == "emergency" ? "emergency-color" : ""}`}>
                      {item?.priority || 'Normal'}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {moment.utc(item.pickupDateTime).format("DD/MM/YYYY hh:mm A")}
                    </CTableDataCell>

                    <CTableDataCell className="text-capitalize">
                      {item?.remarks}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {moment.utc(item.createdAt).local().format("DD/MM/YYYY hh:mm A")}
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      <DeleteModal
        visible={visibleDeleteModal}
        setVisibleDeleteModal={setVisibleDeleteModal}
        addToast={addToast}
      />
      {visibleDeleteConfirmationModal && !!selectedDeletableItem && (<DeleteConfirmationWithRemarks 
        visible={visibleDeleteConfirmationModal} 
        onConfirm={(remarks) => {
          // console.log("====", remarks)
          deleteBookingOrderMutation.mutate({
            id: selectedDeletableItem, remarks: remarks
          })
        }}
        onCancel={() => {
          setVisibleDeleteConfirmationModal(false); 
          setSelectedDeletableItem(null);
        }}
      />)}
      <MessageModal
        visible={visibleMessageModal}
        setVisibleMessageModal={setVisibleMessageModal}
        message={selectedMessage}
        title={selectedModalTitle}
      // addToast={addToast}
      />
    </>
  );
};

export default NewBookingOrdersTable;
